import React from 'react';
import styles from '@/common/containers/TasksList/styles.less';
import { useCurrentDecedentId } from '@/app/providers/DecedentProvider';
import { useTaskListQuery } from '@/entities/decedent';
import { TASK_MODULES, getTaskModuleLabelKey } from '@/common/constants/constants';
import { AssetTasks, DefaultTasks } from '@/common/containers/TasksList/components/index';
import Loader from '@/common/components/Loader/index';
import { Trans, useTranslation } from 'react-i18next';

const TasksList = ({ module }) => {
  const { t } = useTranslation();
  const decedentId = useCurrentDecedentId();
  const { data: list = [], isLoading: loading } = useTaskListQuery(
    decedentId,
    module
  );
  const moduleLabel = t(getTaskModuleLabelKey(module));
  const labelByModule = {
    [TASK_MODULES.IMMEDIATE]: (
      <Trans
        i18nKey="These <1>Immediate tasks</1> are based on the answers you have provided in the questionnaire. If you need to modify your questionnaire answers, click the <2>Edit Questionnaire</2> button above."
        components={{ 1: <b />, 2: <b /> }}
      />
    ),
    [TASK_MODULES.LEGAL]: (
      <Trans
        i18nKey="These tasks are based on answers you provided in the <1>Decedent's profile</1> section and/or the <2>Immediate tasks</2> questionnaire. If you need to modify any answers, go back to those sections to make any corrections."
        components={{ 1: <b />, 2: <b /> }}
      />
    ),
    [TASK_MODULES.MAIN]: (
      <Trans
        i18nKey="These <1>Main tasks</1> are based on the answers you provided in the questionnaire. If you need to modify your answers, click the <2>Edit Questionnaire</2> button above."
        components={{ 1: <b />, 2: <b /> }}
      />
    ),
    [TASK_MODULES.ASSET]: (
      <Trans
        i18nKey="These <1>Assets tasks</1> are based on the answers you have provided in the questionnaire. If you need to modify your answers, click the <2>Edit Questionnaire</2> button above."
        components={{ 1: <b />, 2: <b /> }}
      />
    ),
    [TASK_MODULES.CLOSING]: t(
      'These tasks are required to formally and legally close a decedent’s estate.'
    ),
    default: (
      <Trans
        i18nKey="These tasks are based on answers you've gave in questionnaire. If you need to re-answer some questions click “Edit Questionnaire” in the section above."
      />
    ),
  };

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>
        {t('{{module}} list', { module: moduleLabel })}
      </h3>
      <p className={styles.label}>
        {labelByModule[module] || labelByModule.default}
      </p>
      {!loading ? (
        list.length > 0 &&
        (module === TASK_MODULES.ASSET ? (
          <AssetTasks list={list} module={module} />
        ) : (
          <DefaultTasks list={list} module={module} />
        ))
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default TasksList;
